import React, { useContext } from 'react';
import { LoggerContext } from '../utils/logger';

/**
 * Create Context Consumer HOC for `LoggerContext`, reads logger from context and pass it to children via props
 *
 * @returns {function(*): function(*=, *): *}
 */
export const withLogger = () => (Component) => {
  const LoggerConsumer = (props) => {
    const logger = useContext(LoggerContext);

    return <Component {...props} logger={logger} />;
  };

  LoggerConsumer.displayName = `LoggerConsumer(${Component.displayName || Component.name})`;

  return LoggerConsumer;
};

export default withLogger;
